import { render, staticRenderFns } from "./DiagDetail.vue?vue&type=template&id=fa5f8d40&scoped=true&"
import script from "./DiagDetail.vue?vue&type=script&lang=js&"
export * from "./DiagDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5f8d40",
  null
  
)

component.options.__file = "DiagDetail.vue"
export default component.exports